import { React, useEffect, useState } from 'react';
import { demoProfileData, demoUserActivitiesData } from '../utils/demoData';
import { setUserActivities, setUserProfile } from '../actions';

import BlockList from '../components/BlockList';
import Loading from '../components/Loading';
import { useDispatch } from 'react-redux';

const YourDistanceDemo = () => {
    const [finishedLoading, setFinishedLoading] = useState(false);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setUserProfile(demoProfileData));
        dispatch(setUserActivities(demoUserActivitiesData));
        setTimeout(() => {
            setFinishedLoading(true);
        }, 1500);
    });

    if (finishedLoading === false) {
        return (
            <div>
                <Loading text={'Talking to Strava.'} />
            </div>
        );
    }
    return (
        <div className="container p-0">
            <BlockList />
        </div>
    );
};

export default YourDistanceDemo;
